export default {
  install (vue, opts) {
    vue.$datetime = {
      today: () => {
        var date = new Date()

        var y = date.getFullYear()
        var m = ('0' + (date.getMonth() + 1)).slice(-2)
        var d = ('0' + date.getDate()).slice(-2)

        return y + '-' + m + '-' + d
      }
    }

    	vue.dateFormat = (value, options) => {
    		if (!value) {
    			return ''
    		}
    		if (!options) {
    			options = {}
    		}
    		if (typeof options.time === 'undefined') {
    			options.time = value.length != 10
    		}

    		var date = new Date(value)
    		var today = new Date()
    		var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    		var d = date.getDate()
    		var m = months[date.getMonth()]
    		var h = vue.prependZero(date.getHours())
    		var i = vue.prependZero(date.getMinutes())
    		var y = date.getFullYear()

    		var isToday = date.getDate() == today.getDate() &&
    			date.getMonth() == today.getMonth() &&
    			date.getFullYear() == today.getFullYear()

    		if (options.time && isToday) {
    			return h + ':' + i
    		}

    		return (m + ' ' + d + (y != (new Date()).getFullYear() ? ', ' + y : '')) +
    			(options.time ? (' @ ' + h + ':' + i) : '')
    	}

    	vue.prependZero = value => {
    		return value < 10 ? '0' + value : value
    	}
  }
}
